import * as React from 'react';
import { createElement } from 'react';
import clearIcon from './images/clear@3x.png';
import { changeRule, chooseRule, checkValid } from './functions';
import './style.less';
const TYPE = {
    NORMAL: '1',
    CUSTOM: '2',
};
Number.defaultProps = {
    type: '1',
    inputType: 'number',
    prefixCls: 'im-number',
    prefixcsltype2: 'im-numbertype',
    title: '手机号',
    placeholder: '请输入内容',
    defaultValue: '',
    editable: true,
    titleWidth: 120,
};
function Number(props) {
    const { prefixCls, prefixcsltype2, type, inputType, defaultValue, leftText, placeholder, editable, showClearIcon, maxLength, showErrorInfo, info, errorInfoStyles, containerStyles, label, titleWidth, labelStyles, rightText, titleIcon, rightIcon, } = props;
    const ruleObj = chooseRule({ inputType, leftText, maxLength });
    const [value, setValue] = React.useState(changeRule({ inputType, text: defaultValue }, ruleObj));
    const onChangeText = text => {
        if (checkValid({ inputType, text })) {
            const newValue = changeRule({ inputType, text }, ruleObj);
            setValue(newValue);
            if (props.onChangeText) {
                props.onChangeText(text);
            }
        }
    };
    const onFocus = () => {
        props.onFocus?.();
    };
    const onBlur = () => {
        props.onBlur?.(value);
    };
    const $clearIcon = (createElement("div", { className: `${prefixCls}-right`, onClick: () => {
            onChangeText('');
        } },
        createElement("img", { src: clearIcon })));
    const $rightIcon = (createElement("div", { className: `${prefixCls}-right-icon`, onClick: () => {
            props.onRightIconClick?.();
        } },
        createElement("img", { src: rightIcon })));
    if (type === TYPE.NORMAL) {
        return (createElement("div", { className: `${prefixCls}`, style: containerStyles },
            createElement("div", { style: { width: titleWidth }, className: `${prefixCls}-title` },
                createElement("span", null, ruleObj.leftText),
                Boolean(titleIcon) && (createElement("img", { src: titleIcon, onClick: () => {
                        props.onTitleIconClick?.();
                    } }))),
            createElement("div", { className: `${prefixCls}-center` },
                createElement("input", { type: "text", placeholder: placeholder, disabled: !editable, value: value, onChange: e => {
                        onChangeText(e.target.value);
                    }, maxLength: ruleObj.maxLength, onBlur: onBlur, onFocus: onFocus }),
                Boolean(info) && (createElement("div", { className: `${prefixCls}-center-${showErrorInfo ? 'error' : 'info'}`, style: errorInfoStyles }, info))),
            Boolean(editable && showClearIcon && value) && $clearIcon,
            Boolean(rightIcon) && $rightIcon));
    }
    return (createElement("div", { className: `${prefixcsltype2}` },
        createElement("div", { className: `${prefixcsltype2}-title`, style: labelStyles },
            createElement("span", null, label),
            Boolean(titleIcon) && (createElement("img", { src: titleIcon, onClick: () => {
                    props.onTitleIconClick?.();
                } }))),
        createElement("div", { className: `${prefixcsltype2}-content` },
            createElement("input", { type: "text", disabled: !editable, placeholder: placeholder, value: value, maxLength: ruleObj.maxLength, onBlur: onBlur, onFocus: onFocus, onChange: e => {
                    onChangeText(e.target.value);
                } }),
            Boolean(rightText) && (createElement("div", { className: `${prefixcsltype2}-content-right-text`, onClick: () => {
                    props.onRightTextClick?.();
                } }, rightText)),
            Boolean(rightIcon) && (createElement("img", { src: rightIcon, onClick: () => {
                    props.onRightIconClick?.();
                }, className: `${prefixcsltype2}-content-image` }))),
        createElement("div", { className: `${prefixcsltype2}-info` }, info)));
}
export default Number;
